import { Button, Grid, Typography } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';
import useStyles from '../Ideation/style';
import avatar from 'assets/image/life_with_verses.jpg';
import logo from 'assets/image/ideation/ideaLogo.png';
import blobGroup from 'assets/image/ideation/blob-group.svg';
import note from 'assets/image/ideation/note.svg';
// import { ConvocationSlider } from '../components/ConvocationSlider';
import { useInjectSaga } from 'utilize/injectSaga';
import { useInjectReducer } from 'utilize/injectReducer';
// import reducer from '../reducer';
// import saga from '../saga';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
// import { getConvocationList } from '../actions';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';

export default function QuranPlan() {
	// useInjectSaga({ key: 'ideation', saga });
	// useInjectReducer({ key: 'ideation', reducer });

	const classes = useStyles();
	// const dispatch = useDispatch();

	// const activeConvocationList = useSelector((state) => state?.ideation?.activeConvocationList);
	// const inActiveConvocationList = useSelector((state) => state?.ideation?.inActiveConvocationList);
	// const iAmAdmin = useSelector((state) => state?.ideation?.iAmAdmin);

	// useEffect(() => {
	// 	dispatch(getConvocationList());
	// }, []);
	return (
		<>
			<Helmet>
				<title>عقیق : زندگی با آیه ها </title>
				<meta name="description" content="Helmet application" />
			</Helmet>

			<Grid container justify="center" style={{ backgroundColor: '#fff' }}>
				<Grid container direction="column" className={classes.root}>
					<Grid container  style={{
							flexDirection: 'row',
							marginTop:100, justifyContent:'center',
							gap: 10, alignItems:'center'
						}}>
						<Grid item direction="column" alignItems="center"  >
							{/* <img src={logo} alt="logo" className={classes.convocationAvatar} /> */}
							<Typography variant="h5" style={{ fontWeight: 'bold', marginTop: 10 }}>
							عملیات رمضان المبارک
							</Typography>
							<Grid container style={{ marginTop: 35, gap: 4 }}>
								{/* {iAmAdmin && (
									<Button
										variant="contained"
										className={classes.containedIdeaBtn}
										component={Link}
										to="/ideation/convocation/add"
									>
										ثبت فراخوان جدید
									</Button>
								)} */}
								<Button
									variant="contained"
									className={classes.containedIdeaBtn3}
									component={Link}
									to="/life-with-verses/acts"
								>
								کنش های من 
								</Button>
							</Grid>
						</Grid>
						<img src={avatar} alt="convocation_avatar" style={{maxWidth:'70%',borderRadius:10}} />
					</Grid>
					{/* <Grid container direction="column" style={{ paddingBottom: 90 }}>
						<Grid container alignItems="center" style={{ marginTop: 10 }}>
							<img src={note} alt="note" style={{ width: 30, marginLeft: 10 }} />
							<Typography
								variant="h5"
								style={{
									fontWeight: 'bold',
								}}
							>
								فراخوان های فعال
							</Typography>
						</Grid>
						<Grid container style={{ position: 'relative' }}>
							<ConvocationSlider data={activeConvocationList} />
							<img src={blobGroup} alt="blob-group" className={classes.blobBack} />
						</Grid>
						{inActiveConvocationList?.length && (
							<>
								<Grid container alignItems="center" style={{ marginTop: 10 }}>
									<img src={note} alt="note" style={{ width: 30, marginLeft: 10 }} />
									<Typography
										variant="h5"
										style={{
											fontWeight: 'bold',
										}}
									>
										فراخوان های پیشین
									</Typography>
								</Grid>
								<Grid container style={{ position: 'relative', marginBottom: 60 }}>
									<ConvocationSlider data={inActiveConvocationList} />
									<img src={blobGroup} alt="blob-group" className={classes.blobBack} />
								</Grid>
							</>
						)}
					</Grid> */}
				</Grid>
			</Grid>
		</>
	);
}
